import {createGlobalStyle} from 'styled-components';

const GlobalStyle = createGlobalStyle`
    * {
        margin: 0;
        padding: 0;
    }

    body {
        font-family: ${props => props.theme.fonts.main};
        line-height: 1.5;
        color: #333;
    }

    a {
        text-decoration: none;
        color: inherit;
    }

    button {
        background: none;
        border: none;
        cursor: pointer;
    }

    ul, ol {
        list-style: none;
    }
`;

export default GlobalStyle;